module.exports = __webpack_public_path__ + "img/stick-o-vision-logo.6b5da9c7.png";